import { useCallback } from "react";
import { useAccount, useWriteContract } from "wagmi";
import { waitForTransactionReceipt } from "@wagmi/core";
import { parseEther, parseUnits } from "viem";
import institusionAbi from "../../utils/institusion.json";
import Environment from "../../utils/Environment";
import { wagmiConfig } from "../../wagmiConfig";

const usePurchaseWbtc1 = () => {
  const { address: account, isConnected } = useAccount();
  const { writeContractAsync } = useWriteContract();

  const UsdtAdress = Environment.wbtc;

  const purchaseWbtc1 = useCallback(
    async (amount, postApiRes, id, balance, min) => {
      if (!isConnected || !account) throw new Error("WALLET_NOT_CONNECTED");

      amount = parseFloat(amount).toFixed(6);
      let amount1 = Math.round(amount * 1e12) / 1e12;
      const nd = parseUnits(amount1.toString(), 8);

      let minvalue = min * 0.99;
      minvalue = Math.round(parseFloat(minvalue).toFixed(6) * 1e12) / 1e12;
      minvalue = parseEther(minvalue.toString());

      try {
        const hash = await writeContractAsync({
          address: Environment.instituson,
          abi: institusionAbi,
          functionName: "purchaseWithToken",
          args: [
            UsdtAdress,
            nd,
            postApiRes.code,
            postApiRes?.normalizationFactor,
            postApiRes.referenceTokenPrice,
            minvalue,
            id,
            postApiRes?.price,
            postApiRes.deadline,
            postApiRes?.v,
            postApiRes?.r,
            postApiRes?.s,
          ],
        });

        console.log("WBTC1 tx hash:", hash);

        const receipt = await waitForTransactionReceipt(wagmiConfig, { hash });

        console.log("WBTC1 purchase confirmed:", receipt);

        return { transactionHash: hash, receipt };
      } catch (error) {
        console.error("WBTC1 purchase error:", error);
        throw error;
      }
    },
    [account, isConnected, writeContractAsync]
  );

  return { purchaseWbtc1 };
};

export default usePurchaseWbtc1;
